<template>
    <vx-card id="loader">
        <div class="vx-row mt-5">
            <div class="vx-col w-1/2">
                <h3>Селективные цены</h3>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col w-1/4">
                <label class="vs-input--label"> Id объявления </label>
                <vs-input placeholder="Введите id объявлений (через запятую)" v-model="form.adIdsStr" class="w-full" />
            </div>
            <div class="vx-col w-1/4">
                <label class="vs-input--label"> Id сайта </label>
                <vs-input placeholder="Введите id сайтов (через запятую)" v-model="form.siteIdsStr" class="w-full" />
            </div>
            <div class="vx-col w-1/4">
                <label class="vs-input--label"> Тип устройства </label>
                <v-select
                    :options="dicts.deviceTypes"
                    label="name"
                    placeholder="Выберите тип устройства"
                    class="w-full"
                    v-model="form.deviceTypeId"
                    :reduce="(a) => a.id"
                >
                </v-select>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col">
                <vs-button class="mt-1" color="warning" @click="loadPrices()" type="filled"> Применить </vs-button>
            </div>
        </div>

        <vs-table stripe :data="prices" pagination max-items="100" class="mt-5">
            <template slot="header"></template>
            <template slot="thead">
                <vs-th> Id объявления</vs-th>
                <vs-th> Id сайта</vs-th>
                <vs-th> Домен</vs-th>
                <vs-th> Устройство</vs-th>
                <vs-th> Цена</vs-th>
                <vs-th> Коэффициент</vs-th>
                <vs-th> Селект. цена </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td class="vs-lg-2">{{ tr.adId }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.siteId }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.siteDomain }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.deviceTypeName }}</vs-td>
                    <vs-td class="vs-lg-2" v-if="tr.cpc">{{ tr.cpc | formatNumber(2) }}</vs-td>
                    <vs-td class="vs-lg-2" v-else="tr.epc">{{ tr.epc | formatNumber(2) }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.coeff }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.price | formatNumber(2) }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';

export default {
    name: 'ad-prices',
    data() {
        return {
            prices: [],
            form: {
                deviceTypeId: '',
                adIdsStr: '',
                siteIdsStr: ''
            },
            dicts: {
                deviceTypes: []
            }
        };
    },
    components: {},
    methods: {
        loadPrices() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'ad-prices',
                method: 'GET',
                params: { adIds: this.form.adIdsStr, siteIds: this.form.siteIdsStr, deviceId: this.form.deviceTypeId },
                success: (prices) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.prices = prices || [];
                },
                catch: (err) => {
                    debugger;
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки cелективных цен.',
                        color: 'danger'
                    });
                }
            });
        },
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'ad-prices/dicts',
                method: 'GET',
                success: (dicts) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.dicts.deviceTypes = dicts.deviceTypes;
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки cелективных цен.',
                        color: 'danger'
                    });
                }
            });
        }
    },
    mounted() {
        this.loadDicts();
    },
    components: {
        vSelect
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
    tr > td.actions {
        white-space: nowrap;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
</style>
